import StoreInfoStep from './components/StoreInfoStep.jsx';
import ESignApplicationContainer from './ESignApplicationContainer.jsx';

export default function ESignContractPage() {
  return (
    <ESignApplicationContainer>
      <StoreInfoStep />
    </ESignApplicationContainer>
  );
}
